import { createSelector } from "@reduxjs/toolkit";
import selectMembersRaw from "./selectMembersRaw";

export default createSelector(selectMembersRaw, ({ membersLoading }) => membersLoading);
